import { useEffect } from 'react'
import styled from 'styled-components/macro'

import { Layout } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { AsyncContent } from 'core/ui/async-content/AsyncContent'
import { LoadingState } from 'core/ui/async-content/LoadingState'
import { useAbortController } from 'core/ui/hooks/useAbortController'
import { MainContent } from 'core/ui/MainContent'

import { AwardedEmptyState } from './AwardedEmptyState'
import { AwardedProposalConfirmationHeader } from './AwardedProposalConfirmationHeader'
import { AwardedProposalConfirmationLanesList } from './AwardedProposalConfirmationLanesList'
import { ErrorState } from './ErrorState'
import { useAwardedProposal } from './hooks/useAwardedProposal'

const StyledLayoutStack = styled(Layout.Stack)`
  padding-top: ${getToken('space-2xl')};
`

type AwardedProposalConfirmationPageProps = {
  match: {
    params: {
      id: string
    }
  }
}

export function AwardedProposalConfirmationPage({
  match,
}: AwardedProposalConfirmationPageProps): JSX.Element {
  const { id } = match.params

  const { awardedProposal, awardedProposalStatus, fetchAwardedProposal } = useAwardedProposal()
  const abortController = useAbortController()

  useEffect(() => {
    fetchAwardedProposal(id, abortController)
  }, [abortController, id, fetchAwardedProposal])

  return (
    <MainContent>
      <AsyncContent
        status={awardedProposalStatus}
        loadingState={<LoadingState />}
        errorState={<ErrorState />}
        emptyState={<AwardedEmptyState />}
        count={awardedProposal?.lanes.length}
      >
        {awardedProposal && (
          <StyledLayoutStack>
            <AwardedProposalConfirmationHeader awardedProposal={awardedProposal} />
            <AwardedProposalConfirmationLanesList rfpId={id} awardedProposal={awardedProposal} />
          </StyledLayoutStack>
        )}
      </AsyncContent>
    </MainContent>
  )
}
